import domReady from '@wordpress/dom-ready';
import { _x } from '@wordpress/i18n';

domReady(() => {
  const snippet = document.querySelector('#findstr-snippet');
  const copyButton = document.querySelector('#findstr-snippet-button');
  const copyButtonText = document.querySelector('#findstr-snippet-button span');

  if (snippet && copyButton && copyButtonText) {
    copyButton.addEventListener('click', () => {
      const textareaItem = document.createElement('textarea');
      textareaItem.value = snippet.textContent;
      document.body.appendChild(textareaItem);
      textareaItem.select();
      document.execCommand('copy');
      document.body.removeChild(textareaItem);

      copyButtonText.textContent = _x(
        'Copied!',
        'Snippet copied to clipboard',
        'vtx'
      );

      setTimeout(() => {
        copyButtonText.textContent = _x(
          'Copy',
          'Copy snippet to clipboard',
          'vtx'
        );
      }, 2000);
    });
  }
});
